module.exports = __webpack_public_path__ + "a01298e6e43cc5f21f72f375fa24f6c9.MP3";